"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlatformAccount = void 0;
const utils_1 = require("../../utils");
const operation_1 = require("../operation");
const transaction_1 = require("../transaction");
const account_1 = require("./account");
class PlatformAccount extends account_1.UtxoAccount {
    provider;
    constructor(provider, wallet) {
        super(provider.platformChain, provider.platformApi, wallet);
        this.chain = provider.platformChain;
        this.provider = provider;
    }
    async estimate(operation) {
        const provider = await this.provider.getStaticProvider();
        if (operation.type === operation_1.NetworkOperationType.ValidatePrimary) {
            return await (0, transaction_1.estimatePlatformValidatePrimaryOperation)(provider, operation, this);
        }
        else if (operation.type === operation_1.NetworkOperationType.DelegatePrimary) {
            return await (0, transaction_1.estimatePlatformDelegatePrimaryOperation)(provider, operation, this);
        }
        else if (operation.type === operation_1.NetworkOperationType.Send) {
            return await (0, transaction_1.estimateSendOperation)(provider, this.chain, this, operation);
        }
        else if (operation.type === operation_1.NetworkOperationType.SendUtxo) {
            return await (0, transaction_1.estimateSendUtxoOperation)(provider, this.chain, this, operation);
        }
        else if (operation.type === operation_1.NetworkOperationType.CreateSupernet) {
            return await (0, transaction_1.estimatePlatformCreateSupernetOperation)(provider, operation, this);
        }
        else if (operation.type === operation_1.NetworkOperationType.ValidateSupernet) {
            return await (0, transaction_1.estimatePlatformAddSupernetValidatorOperation)(provider, operation, this);
        }
        else if (operation.type === operation_1.NetworkOperationType.RemoveSupernetValidator) {
            return await (0, transaction_1.estimatePlatformRemoveSupernetValidatorOperation)(provider, operation, this);
        }
        else if (operation.type === operation_1.NetworkOperationType.CreateChain) {
            return await (0, transaction_1.estimatePlatformCreateChainOperation)(provider, operation, this);
        }
        throw new utils_1.AccountError(`unsupported operation: ${operation.type} for the chain with id: ${this.chain.id}`);
    }
    async execute(summary) {
        super.spend(summary.spendings);
        const operation = summary.operation.type;
        if (operation === operation_1.NetworkOperationType.ValidatePrimary) {
            const transaction = summary.fee.transaction;
            this.verifyAndFixStakeTransaction(transaction.validator);
            await this.executeAndTrackTransaction(summary, transaction_1.TransactionType.PrimaryValidation);
        }
        else if (operation === operation_1.NetworkOperationType.DelegatePrimary) {
            const transaction = summary.fee.transaction;
            this.verifyAndFixStakeTransaction(transaction.validator);
            await this.executeAndTrackTransaction(summary, transaction_1.TransactionType.PrimaryDelegation);
        }
        else if (operation === operation_1.NetworkOperationType.Send) {
            await this.executeAndTrackTransaction(summary, transaction_1.TransactionType.Send);
        }
        else if (operation === operation_1.NetworkOperationType.SendUtxo) {
            await this.executeAndTrackTransaction(summary, transaction_1.TransactionType.Send);
        }
        else if (operation === operation_1.NetworkOperationType.CreateSupernet) {
            await this.executeAndTrackTransaction(summary, transaction_1.TransactionType.CreateSupernet);
        }
        else if (operation === operation_1.NetworkOperationType.ValidateSupernet) {
            const transaction = summary.fee.transaction;
            this.verifyAndFixStakeTransaction(transaction.validator);
            await this.executeAndTrackTransaction(summary, transaction_1.TransactionType.ValidateSupernet);
        }
        else if (operation === operation_1.NetworkOperationType.RemoveSupernetValidator) {
            await this.executeAndTrackTransaction(summary, transaction_1.TransactionType.RemoveSupernetValidator);
        }
        else if (operation === operation_1.NetworkOperationType.CreateChain) {
            await this.executeAndTrackTransaction(summary, transaction_1.TransactionType.CreateChain);
        }
        // balances fetching is needed to get new utxos creating from this operation
        await super.refreshBalances();
    }
    // Doing the check and fix here before a rework of unsignedTx usage in op summaries.
    // This avoids to send tx with too low staking period which can easily happen when
    // users are trying to stake for staking periods of minStakeDuration.
    verifyAndFixStakeTransaction(validator) {
        const minStakeDuration = this.provider.platformChain.stakeConfig.minStakeDuration;
        // if the stake period the user entered is too low it is better to throw an error than
        // adjusting it and sending it so it does not have an unexpected behaviour
        if (validator.getStakePeriod() < minStakeDuration) {
            throw new utils_1.StakeError(`stake period of ${validator.getStakePeriod()} is too low: want at least ${minStakeDuration}`);
        }
        // resync of start time to match chain timestamp
        // note: maybe use actual chain timestamp instead of local user time
        // some may have reconfigured their clock
        validator.startTime = utils_1.TimeUtils.now();
        // resync endTime to accomodate for minStakeDuration according to new startTime
        // give it an extra 60 seconds headroom to make sure the staking does not fail
        if (validator.getStakePeriod() < minStakeDuration) {
            validator.endTime = validator.startTime + minStakeDuration + BigInt(60);
        }
    }
    async executeAndTrackTransaction(summary, type) {
        const executable = summary.getExecutable();
        const signedTx = await summary.fee.transaction.signTransaction(this.signers);
        const transactionHash = (await executable.provider.platformApi.issueTx(signedTx)).txID;
        await executable.trackPlatformTransaction(transactionHash, type);
    }
}
exports.PlatformAccount = PlatformAccount;
